export default "__VITE_ASSET__Brzu2oR6__"